import { render, staticRenderFns } from "./spot.vue?vue&type=template&id=68f89a87&scoped=true"
import script from "./spot.vue?vue&type=script&lang=js"
export * from "./spot.vue?vue&type=script&lang=js"
import style0 from "./spot.vue?vue&type=style&index=0&id=68f89a87&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f89a87",
  null
  
)

export default component.exports